import { 
    Drawer,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    DrawerHeader,
    DrawerBody,
} from "@chakra-ui/react";
import type { DrawerFormProps } from "./types";

const DrawerForm = ({
    isOpen, 
    onClose, 
    size, 
    title, 
    closeOnOverlayClick, 
    location,
    children
}:DrawerFormProps) => {
    return(
        <Drawer 
            isOpen={isOpen} 
            onClose={onClose} 
            size={size} 
            closeOnOverlayClick={closeOnOverlayClick}
            placement={ location ?? 'end' }
        >
            <DrawerOverlay/>
            <DrawerContent>
                <DrawerHeader>{title}</DrawerHeader>
                <DrawerCloseButton/>
                <DrawerBody position="relative">
                    {children}
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    )
}

export default DrawerForm;